// extracted by mini-css-extract-plugin
export var promotionLink = "_vv-0";